export default __webpack_public_path__ + "static/media/CS_198.fe3324e0.png";